import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../_services/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser) {
            var permission = state.url.split("/");
            var permission1 = permission[2];
            /* var now = new Date().getTime();
            if (now - Number(sessionStorage.getItem('refreshTime')) < 10000) {
                this.router.navigate(['/login']);
                return false;
            }

            sessionStorage.setItem('refreshTime', JSON.stringify(now)); */

            // check if route is restricted by role
            if (route.data.roles && route.data.roles.indexOf(currentUser.role) === -1 || currentUser.role.indexOf(permission1) === -1) {
                // role not authorised so redirect to home page
                if(permission1 == 'dashboard' && currentUser.role.indexOf(permission1) === -1){
                    this.router.navigate(['/login']);
                    return false;
                }else{
                    this.router.navigate(['adminhkbkcms/dashboard/default']);
                    return false;
                }
                
            }

            // authorised so return true
            return true;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}